<template>
  <v-app>
      <v-container class="h4">
          <v-row class="justify-content-center bold mt-5">
              <v-col lg="4" class="text-right">Empleado</v-col>
              <v-col lg="6">
                  <v-select :items="users"
                  item-text="full_name"
                  item-value="id"
                  v-model="anticipo.recibe">
                    <div slot="prepend">
                        <v-icon>mdi-account</v-icon>
                    </div>
                  </v-select>
              </v-col>
          </v-row>
          <v-row class="justify-content-center bold">
              <v-col lg="4" class="text-right">Anticipo</v-col>
              <v-col lg="6">
                  <v-text-field
                  label="Anticipo"
                  v-model="anticipo.anticipo">
                  <div slot="prepend">
                      <v-icon>mdi-currency-usd</v-icon>
                  </div>
                  </v-text-field>
              </v-col>
          </v-row>   
        <v-row class="justify-content-center">
            <v-col lg="10" class="text-center">
                <v-btn color="info" @click="setData">Agregar</v-btn>
            </v-col>
        </v-row>       
      </v-container>
  </v-app>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return {
            anticipo: {
                recibe: 0,
                anticipo: null
            },users: []
        }
    },methods: {
        setData: async function(){

            await axios.put('https://127.0.0.01:3000/anticipo/',this.anticipo)
            //console.log(data)
        },
        getData: async function(){
            let {data} = await axios.get('https://127.0.0.1:3000/user')
            this.users=data
        },
        getUser: async function(){
            let {data} = await axios.get(`https://127.0.0.1/3000/user/${this.id}`)
            this.user=data

        }
    },
    mounted(){
        this.getData()
    },
    watch:{
        id: {
            deep: true,
            handler: function()
            {
                this.getUser()
            }
        }
    }
}
</script>

<style>
    .bold{
        font-weight: bolder
    }
</style>